/* 📁 ASSETS*/
import { Advertencia, Critico, PerdaComunicacao, Manutencao, NormalIcon } from "../../../../Assets/icons";

/* 🎨 STYLES */
import { Container, StateIndicator, NameContainer, ValueContainer, ColumnContainer} from "./styles";

const EquipamentLine = ({ $background, dado }) => {
    return(
        <Container $background={$background}>
            
            <ColumnContainer>
                <StateIndicator src={dado.status === 4 ? Manutencao : dado.status === 3 ? PerdaComunicacao : dado.status === 2 ? 
                    Critico: dado.status === 1 ? Advertencia : NormalIcon}/>

                <NameContainer>
                    {dado.name}
                </NameContainer>
            </ColumnContainer>

            <ColumnContainer>
                <ValueContainer>
                    {dado.value || dado.value === 0 ? dado.value : 'SD'}  
                </ValueContainer>
                
                {dado.value2 ? 
                    <ValueContainer>
                        {dado.value2}
                    </ValueContainer>
                    :
                    <ValueContainer>
                        {dado.unit}
                    </ValueContainer>
                }
            </ColumnContainer>
        </Container>
    )
}

export default EquipamentLine;